import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { ASSETS, SHOP_URL } from "../lib/assets";

export const Hero = () => {
  const { t } = useI18n();
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden"
    >
      {/* Stars background */}
      <div className="absolute inset-0 pointer-events-none opacity-70">
        <div className="absolute inset-0" style={{
          backgroundImage:
            "radial-gradient(2px 2px at 20% 30%, rgba(255,255,255,0.7), transparent 60%), radial-gradient(1.5px 1.5px at 70% 20%, rgba(0,255,255,0.7), transparent 60%), radial-gradient(2px 2px at 80% 70%, rgba(255,230,0,0.6), transparent 60%), radial-gradient(1.5px 1.5px at 30% 80%, rgba(255,0,68,0.6), transparent 60%), radial-gradient(1px 1px at 50% 50%, rgba(255,255,255,0.5), transparent 60%)",
          backgroundSize: "600px 600px, 700px 700px, 800px 800px, 750px 750px, 500px 500px",
        }} />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 pt-16 sm:pt-24 pb-20 sm:pb-28 grid lg:grid-cols-12 gap-10 items-center">
        {/* Left: title */}
        <div className="lg:col-span-7 z-10">
          <div className="font-pixel text-[#00ffff] glow-cyan text-xl tracking-[0.4em] mb-3">
            ▮ INSERT CARTRIDGE
          </div>
          <h1 className="kanji-mega text-white drop-shadow-[0_0_20px_rgba(0,255,255,0.45)] flicker">
            <div className="flex">
              <span className="text-[#00ffff] glow-cyan">世</span>
              <span className="text-[#ffe600] glow-yellow">界</span>
            </div>
            <div className="flex">
              <span className="text-[#ff0044] glow-pink">転</span>
              <span className="text-[#2bff88] glow-green">生</span>
            </div>
          </h1>
          <div className="romaji-mega text-white mt-4 glow-cyan">
            SEKAI&nbsp;TENSEI
            <span className="blink text-[#ff0044] ml-2">▮</span>
          </div>
          <p className="font-mono text-[#e2e8f0]/80 mt-6 max-w-xl text-sm sm:text-base leading-relaxed">
            {t.hero.tagline}
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-4">
            <a
              data-testid="hero-preorder-link"
              href={SHOP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-retro text-2xl px-6 py-3"
            >
              ▶ {t.hero.preorder}
            </a>
            <a
              data-testid="hero-scroll-link"
              href="#video"
              className="font-pixel text-[#00ffff] glow-cyan text-xl tracking-[0.25em] border-b-2 border-[#00ffff]/40 hover:border-[#00ffff] pb-1"
            >
              {t.hero.scroll}
            </a>
          </div>

          <div className="mt-10 flex items-center gap-3 font-pixel text-base text-[#94a3b8] uppercase tracking-widest">
            <span className="text-[#2bff88] glow-green">▮</span> AMSTRAD GX4000
            <span className="text-[#ff0044] glow-pink">/</span> CPC6128 PLUS
            <span className="text-[#ff0044] glow-pink">/</span> CARTRIDGE
          </div>
        </div>

        {/* Right: Nozora sprite */}
        <div className="lg:col-span-5 relative flex justify-center z-10">
          <div className="relative w-[280px] sm:w-[360px] aspect-square">
            <div className="absolute inset-0 rounded-full" style={{
              background: "radial-gradient(closest-side, rgba(255,0,68,0.35), transparent 70%)",
              filter: "blur(8px)",
            }} />
            <div className="absolute inset-0 float-y">
              <img
                data-testid="hero-nozora-sprite"
                src={ASSETS.nozora}
                alt="Nozora — sprite"
                className="pixelated w-full h-full object-contain drop-shadow-[0_0_18px_rgba(0,255,255,0.5)] -scale-x-100"
              />
            </div>
            <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 w-56 h-2 rounded-full bg-[#00ffff]/40 blur-md" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
